import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';

class PrototypeVideoMobileScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            locale: props.locale,
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }

    render() {
        return (
            <div className="prototype video-object-wrapper-prototype">
                <div className="video-col single">
                    <div className="object-container">
                        <div className="video-object">
                            <div className={`video-thumbnail-wrapper play`}>
                                <img src={require(`../../../assets/images/placeholder/placeholder_thumbnail.jpg`)} alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

PrototypeVideoMobileScreen.propTypes = {
    locale: PropTypes.object,
};

PrototypeVideoMobileScreen.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};

}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrototypeVideoMobileScreen);



/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/PrototypeVideoMobileScreen.js
 **/